import { nhanKyDoiSoat } from '@qlk/shared';
import { useState } from 'react';

import { HopThoai, Nut, O, dinhDangTien } from '../../../ui/index.js';
import { useMoLaiDoiSoat } from '../api.js';

export interface HopMoLaiProps {
  period: string;
  userId: string;
  tenNguoi: string;
  phaiTra: number;
  onDong: () => void;
}

/** Số ký tự tối thiểu của lý do — khớp `moLaiDoiSoatSchema` ở shared. */
const TOI_THIEU = 5;

/**
 * Mở lại một kỳ **đã chốt** (chưa thanh toán).
 *
 * Nói rõ hai điều người bấm cần biết: bản chụp cũ **không mất** (nó thành một
 * phiên bản trong lịch sử), và lý do là bắt buộc vì nó đi vào nhật ký.
 */
export function HopMoLai({ period, userId, tenNguoi, phaiTra, onDong }: HopMoLaiProps) {
  const moLai = useMoLaiDoiSoat();
  const [lyDo, setLyDo] = useState('');

  return (
    <HopThoai
      title={`Mở lại kỳ đã chốt — ${tenNguoi}`}
      rong="md"
      onDong={onDong}
      chanHop={
        <>
          {moLai.isError && (
            <p role="alert" className="mr-auto self-center text-phu text-bad-chu">
              {moLai.error.message}
            </p>
          )}
          <Nut kieu="phu" onClick={onDong}>
            Huỷ
          </Nut>
          <Nut
            kieu="chinh"
            disabled={lyDo.trim().length < TOI_THIEU}
            dangChay={moLai.isPending}
            onClick={() => {
              moLai.mutate({ period, userId, lyDo: lyDo.trim() }, { onSuccess: onDong });
            }}
          >
            Mở lại
          </Nut>
        </>
      }
    >
      <div className="space-y-4">
        <p className="text-co-ban text-chu">
          {nhanKyDoiSoat(period)} của <strong>{tenNguoi}</strong> đang chốt ở{' '}
          <strong className="tabular-nums">{dinhDangTien(phaiTra)}</strong>. Mở lại sẽ tính lại từ
          dữ liệu hiện tại.
        </p>

        <p className="rounded-[10px] bg-info-nen px-3 py-2 text-phu text-info-chu">
          Bản chụp hiện tại <strong>không bị xoá</strong>: nó thành một phiên bản trong lịch sử
          chốt, kèm lý do bạn ghi dưới đây. Lần chốt sau tạo phiên bản mới.
        </p>

        <O
          label="Lý do mở lại"
          value={lyDo}
          onChange={setLyDo}
          nhieuDong
          required
          moTa={`Ít nhất ${String(TOI_THIEU)} ký tự. Lý do đi vào nhật ký thao tác.`}
        />
      </div>
    </HopThoai>
  );
}
